<template>
  <!-- <nav>
    <router-link to="/">Home</router-link> |
    <router-link to="/payment_form_subscription">Subscription</router-link> |
    <router-link to="/payment_form_card">Card</router-link>
  </nav> -->
  <router-view/>
</template>

<style lang="scss">
#app {
  
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

nav {
  padding: 30px;

  a {
    font-weight: bold;
    color: #2c3e50;

    &.router-link-exact-active {
      color: #42b983;
    }
  }
}
</style>
